import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=647ba932&"
import script from "./disclaimer.vue?vue&type=script&lang=ts&"
export * from "./disclaimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BContainer: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/BContainer.vue').default})
